import { GoldenSourceHelper } from "../../app/Switch_Core_React_Standards";
import { dbPayload } from "../../auth/registered/SEC_00_DB_Payload";

/**
 * 🛰️ GET ALL OWNERSHIP LINKS
 * Every active parent/child edge in the corporate hierarchy. Loaded in full
 * client-side (same scale assumption as fetchCorporateRegistry) so cycle
 * detection can walk the whole graph before offering a link in the UI.
 */
export const fetchOwnershipLinks = async (config) => {
    try {
        const rawData = await dbPayload(
            "/api/v1/sustina/ownership/get-all",
            "POST",
            config.siteKey,
            {}
        );

        const res = GoldenSourceHelper.normalize(rawData);
        return res.success ? res.data : [];
    } catch (err) {
        console.error("Ownership Links Fetch Failed:", err);
        return [];
    }
};

/**
 * 🛰️ ASSIGN OWNERSHIP LINK
 * Links childEntityId under parentEntityId. Cycle/self-link rejection is
 * enforced server-side in Corp.usp_Z_01_06_Ownership_Assign.
 */
export const assignOwnershipLink = async (parentEntityId, childEntityId, ownershipPercent, config) => {
    try {
        const payload = {
            ParentEntityId: parentEntityId,
            ChildEntityId: childEntityId,
            OwnershipPercent: ownershipPercent ?? null,
        };

        const rawData = await dbPayload(
            "/api/v1/sustina/ownership/assign",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi(payload)
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Ownership link failed.");
        return res.data;
    } catch (err) {
        console.error("Ownership Assign Error:", err);
        throw err;
    }
};

/**
 * 🛰️ REVOKE OWNERSHIP LINK
 */
export const revokeOwnershipLink = async (parentEntityId, childEntityId, config) => {
    try {
        const payload = { ParentEntityId: parentEntityId, ChildEntityId: childEntityId };

        const rawData = await dbPayload(
            "/api/v1/sustina/ownership/revoke",
            "POST",
            config.siteKey,
            GoldenSourceHelper.prepareForApi(payload)
        );

        const res = GoldenSourceHelper.normalize(rawData);
        if (!res.success) throw new Error(res.message || "Ownership revoke failed.");
        return true;
    } catch (err) {
        console.error("Ownership Revoke Error:", err);
        throw err;
    }
};
